module.exports = __webpack_public_path__ + "media/images/sharing/energiefranken-og-it-6699c5e9939c45ce188caa1698ebbf0b.png";